// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".featured-nav-menu{width:800px !important}.featured-nav-menu-title{border-right:1px solid #e6e6e6}", ""]);
// Exports
module.exports = exports;
